// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + {"215":"4d8bd33c08942890320c","524":"b76820f44f03ee1b0415"}[chunkId] + ".css";
};